import * as React from 'react';

export const useContextMenu = (menu : any, onShow: any = null, onHide: any = null) => {

    const [xPos, setXPos] = React.useState("0px");
    const [yPos, setYPos] = React.useState("0px");
    const [showMenu, setShowMenu] = React.useState(false);

    const handleContextMenu = React.useCallback(
        (e) => {
            e.preventDefault();

            if (menu) {

                (e.clientX + 230 > window.innerWidth)
                    ? setXPos(`${e.clientX - 230}px`)
                    : setXPos(`${e.clientX}px`);
                
                const offset = menu.props.heightOffset;
                if (e.clientY + offset > window.innerHeight) {
                    if (offset >= 415) {
                        setYPos(`${e.clientY - 320}px`);
                    }
                    else if (offset > 250 && offset <= 390) {
                        setYPos(`${e.clientY - 285}px`);
                    }
                    else if(offset < 200) {
                        setYPos(`${e.clientY - 70}px`);
                    }
                    else {
                        setYPos(`${e.clientY - 145}px`);
                    }                        
                }
                else {
                    setYPos(`${e.clientY}px`);
                }

                setShowMenu(true);
                if (onShow) {
                    onShow();
                }
            }
        },
        [setXPos, setYPos, menu]
    );

    const handleClick = React.useCallback(() => {
        showMenu && setShowMenu(false);
        if (onHide) {
            onHide();
        }
    }, [showMenu]);

    React.useEffect(() => {
        document.addEventListener("click", handleClick);
        document.addEventListener("contextmenu", handleContextMenu);
        return () => {
            document.addEventListener("click", handleClick);
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    });

    return { xPos, yPos, showMenu };
};